exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-book-tsx": () => import("./../../../src/templates/book.tsx" /* webpackChunkName: "component---src-templates-book-tsx" */),
  "component---src-templates-chapter-tsx": () => import("./../../../src/templates/chapter.tsx" /* webpackChunkName: "component---src-templates-chapter-tsx" */),
  "component---src-templates-post-tsx": () => import("./../../../src/templates/post.tsx" /* webpackChunkName: "component---src-templates-post-tsx" */)
}

